import React from "react";
import banner from "assets/img/profile/banner.png";
import Card from "components/card";

const Banner = ({ data }) => {
  return (
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] !border-navy-700 bg-pink-400">
          <img
            className="h-full w-full rounded-full"
            src={data.profileImg}
            alt="Profile"
          />
        </div>
      </div>

      {/* Name and position */}
      <div className="mt-16 flex flex-col items-center">
        <h4 className="text-xl font-bold text-white">
          {data.lastName ? data.lastName : "--"}
        </h4>
        <p className="text-base font-normal text-gray-600">
          {data.email ? data.email : "--"}
        </p>
        <p className="text-base font-normal text-gray-600">
          {data.mobile ? data.mobile : "--"}
        </p>
      </div>

      {/* Post followers */}
      <div className="mb-3 mt-6 flex gap-4 md:!gap-14">
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-white">{data.gender}</p>
          <p className="text-sm font-normal text-gray-600">Gender</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-white">{data.dob}</p>
          <p className="text-sm font-normal text-gray-600">DOB</p>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-2xl font-bold text-white">{data.isActive}</p>
          <p className="text-sm font-normal text-gray-600">Activated</p>
        </div>
      </div>
    </Card>
  );
};

export default Banner;
